import { API_BASE_URL } from "./constants";



export const fetchChallenge = async (address) => {
    const response = await fetch(`${API_BASE_URL}/auth/challenge?address=${address}`);
    const data = await response.json();
    return data.challenge;
};

export const postChallengeResponse = async ({ address, message, signature }) => {
    const response = await fetch(`${API_BASE_URL}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ address, message, signature }),
    });
    return response.json();
};

